(ns machtfit.startpage.footer
  (:require [cljs-time.core :as time]
            [machtfit.app.routes :as routes]
            [machtfit.core :as machtfit]
            [machtfit.init :as-alias init]
            [machtfit.language :as language]
            [machtfit.startpage.layout :as layout]
            [machtfit.startpage.statics :as statics]
            [machtfit.translation :refer [t]]
            [re-frame.core :as rf]))

(defn- external-link [external-page]
  (let [{:keys [url target]
         link-name :name} (external-page statics/external-pages)]
    [:li
     [:a {:href @(rf/subscribe [:get [:urls url]])
          :target target
          :title (t link-name)
          :data-ph-capture-attribute-ui_id (str "footer__link__" (name external-page))}
      [t link-name]]]))

;; A route the server renders: a plain anchor, so the click leaves the app instead of
;; being intercepted by `attrs-link-to-page`. The path is written out rather than read
;; from `[:urls]` because that map is the response of the `urls` operation, which
;; golden-masters/contract/records.json records in six cells; adding a key to it moves
;; them (DEV-3661).
(defn- migrated-link [ui-id path link-name]
  [:li
   [:a {:href path
        :title (t link-name)
        :data-ph-capture-attribute-ui_id (str "footer__link__" ui-id)}
    [t link-name]]])

(defn- update-cookie-preferences []
  [:li
   [:button.text-left
    {:on-click #(.showKlaroModal js/window)}
    (t {:de "Cookie-Einstellungen aktualisieren"
        :en "Update Cookie Preferences"})]])

(defn footer [{:keys [spa-lang-switcher?]
               :or {spa-lang-switcher? @(rf/subscribe [::init/is-spa?])}}]
  [:footer.footer
   [:div.footer__top
    [:div.container.container-xl
     [:div.footer__logo
      [:a.footer__logo-link (routes/attrs-link-to-page {:id :home})
       [layout/subdomain-logo]]
      [:div.footer__cooperation
       [:span (t {:de "In Zusammenarbeit mit"
                  :en "In cooperation with"})]
       ;; Show the rainbow pride logo for the whole of June.
       (if (= 6 (time/month (time/now)))
         [:img {:src (machtfit/static "img/machtfit-logo-rainbow.png")
                :alt (t {:de "Regenbogenversion des machtfit-Logos"
                         :en "Rainbow version of the machtfit logo"})}]
         [:img {:src (machtfit/static "img/machtfit-logo.png")
                :alt (t {:de "machtfit-Logo"
                         :en "machtfit logo"})}])]]
     [:div.footer__stores
      [:span (t {:de "Einfach fit zu Hause oder woanders:"
                 :en "Simply fit from home or anywhere:"})]
      [:a {:href "https://apps.apple.com/de/app/machtfit/id1116916354"
           :target "_blank"}
       [:img {:src (machtfit/static "img/stepchall/app-store-de.svg")
              :alt (t {:de "Logo des Apple App Store"
                       :en "Apple's App Store logo"})}]]
      [:a {:href "https://play.google.com/store/apps/details?id=de.machtfit.poc"
           :target "_blank"}
       [:img {:src (machtfit/static "img/stepchall/google-play-de.svg")
              :alt (t {:de "Logo des Google Play Store"
                       :en "Google's Play Store logo"})}]]]]]
   [:div.footer__main
    [:div.footer__nav.container.container-xl
     [:div.footer__nav-col
      [:h5 (t {:de "Service"
               :en "Service"})]
      [:ul
       [migrated-link "contact" "/contact/" {:de "Kontakt" :en "Contact"}]
       [external-link :help]
       (when (= @(rf/subscribe [:get [:user :company-id]])
                223) ; AOK Niedersachsen
         [:li [:a {:href "https://www.aok.de/pk/barriere-melden/?hidden_p=10077"
                   :target "_blank"}
               (t {:de "Barriere melden"
                   :en "Report barrier"})]])]]
     [:div.footer__nav-col
      [:h5 (t {:de "Rechtliches"
               :en "Legal issues"})]
      [:ul
       [update-cookie-preferences]
       [external-link :privacy-policy]
       [migrated-link "imprint" "/impressum/"
        {:de "Impressum"
         :en "Imprint"}]
       [migrated-link "accessibility" "/accessibility-statement/"
        {:de "Erklärung zur Barrierefreiheit"
         :en "Accessibility Statement"}]
       [migrated-link "license" "/license-information/"
        {:de "Softwarelizenzinformationen"
         :en "Software License Information"}]
       [external-link :terms]]]
     [:div.footer__nav-col.footer__language
      [:h5 (t {:de "Sprache"
               :en "Language"})]
      [:ul
       [:li [language/switcher spa-lang-switcher? :de "De" "Deutsch"]]
       [:li [language/switcher spa-lang-switcher? :en "En" "English"]]]]
     [:div.footer__nav-col
      [:h5 (t {:de "Folge uns"
               :en "Follow us"})]
      [:ul.footer__img-list
       [:li [:a {:href "https://www.facebook.com/machtfit.de/"
                 :target "_blank"}
             [:img {:src (machtfit/static "img/footer/fb.svg")
                    :alt (t {:de "Facebook-Logo"
                             :en "Facebook's logo"})}]]]
       [:li [:a {:href "https://www.instagram.com/machtfit/"
                 :target "_blank"}
             [:img {:src (machtfit/static "img/footer/insta.svg")
                    :alt (t {:de "Instagram-Logo"
                             :en "Instagram's logo"})}]]]
       [:li [:a {:href "https://de.linkedin.com/company/machtfit-gmbh"
                 :target "_blank"}
             [:img {:src (machtfit/static "img/footer/linked.svg")
                    :alt (t {:de "LinkedIn-Logo"
                             :en "LinkedIn's logo"})}]]]]]
     [:div.footer__stores.footer__stores--alt
      [:span (t {:de "Einfach fit zu Hause oder woanders:"
                 :en "Simply fit from home or anywhere:"})]
      [:a {:href "https://apps.apple.com/de/app/machtfit/id1116916354"
           :target "_blank"}
       [:img {:src (machtfit/static "img/stepchall/app-store-de.svg")
              :alt (t {:de "Logo des Apple App Store"
                       :en "Apple's App Store logo"})}]]
      [:a {:href "https://play.google.com/store/apps/details?id=de.machtfit.poc"
           :target "_blank"}
       [:img {:src (machtfit/static "img/stepchall/google-play-de.svg")
              :alt (t {:de "Logo des Google Play Store"
                       :en "Google's Play Store logo"})}]]]
     [:div.footer__certs-payments.mobile-hide
      [:div.footer__nav-col
       [:h5 (t {:de "Zertifikate"
                :en "Certificates"})]
       [:ul.footer__img-list
        [:li [:a {:href (str "https://certcheck.dqsglobal.com/?reference=538567+ISMS22&lang="
                             (name @(rf/subscribe [:get [:language]])))
                  :target "_blank"}
              [:img {:src (machtfit/static "img/footer/dqs-iso.svg")
                     :alt (t {:de "Logo für das ISO 27001:2022 Zertifikat"
                              :en "Logo for the ISO 27001:2022 certificate"})}]]]
        [:li [:img {:src (machtfit/static "img/footer/dev_host_germany_grey.svg")
                    :alt (t {:de "Logo gehostet in Deutschland"
                             :en "Logo hosted in Germany"})}]]]]
      [:div.footer__nav-col
       [:h5 (t {:de "Bezahlmethoden"
                :en "Payment methods"})]
       [:ul.footer__img-list
        [:li [:img {:src (machtfit/static "img/footer/mastercard.svg")
                    :alt (t {:de "Mastercard-Logo"
                             :en "Mastercard logo"})}]]
        [:li [:img {:src (machtfit/static "img/footer/visa.svg")
                    :alt (t {:de "Visa-Card-Logo"
                             :en "Visa Card's logo"})}]]
        [:li [:img {:src (machtfit/static "img/footer/paypal.svg")
                    :alt (t {:de "Paypal-Logo"
                             :en "Paypal's logo"})}]]]]]
     [:div.footer__nav-col.footer__copyright
      [:p (str "©machtfit " (time/year (time/time-now)) " · Copyright Reserved")]]]]])
